module.exports = __webpack_public_path__ + "img/Sushi Icon - charcoal.3fd8bc3a.svg";